// import axios from "axios";

import { Customer, Product } from "./interfaces";

export const getDefaultCustomer = (): Customer => {
  return {
    Kundennummer: 0,
    Kunde: "",
    Straße: "",
    plz: 0,
    Ort: "",
    email: [""],
  };
};

// export const getRandomCustomer = async () => {
//   try {
//     const response = await axios.get("https://randomuser.me/api/");
//     const customer = response.data.results[0];

//     // Get current date and time
//     let now = new Date();

//     // Calculate start and end dates for last year
//     let startOfLastYear = new Date(now.getFullYear() - 1, 0, 1).getTime();
//     let endOfLastYear = new Date(now.getFullYear() - 1, 11, 31).getTime();

//     // Generate a random timestamp between start and end of last year
//     let randomTimestamp =
//       Math.floor(Math.random() * (endOfLastYear - startOfLastYear + 1)) +
//       startOfLastYear;

//     const randCustomer = {
//       Kundennummer: customer.id.value,
//       Kunde: `${customer.name.first} ${customer.name.last}`,
//       Straße: customer.location.street.name  ,
//       plz: customer.location.postcode,
//       Ort: customer.location.city,
//       ScheinDate: new Date(randomTimestamp),
//     };
//     console.log("customer", randCustomer);
//     return randCustomer;
//   } catch (error) {
//     console.error(error);
//   }
// };

export const getDefaultProduct = (): Product => {
  return {
    artikelgruppe: "",
    artikel: "",
    beschreibung: "",
    vk: 0,
    id: 0,
    menge: 1,
    kommentar: "",
    provisionsnehmer: "",
    provisionstyp: "Nicht ausgewählt",
    mwst: 0,
    provisionstypid: 0,
    customprovisionsnehmer: false,
  };
};

export const initialServiceReportData = {
  customerNr: 0,
  customerName: "",
  address: "",
  comment: "",
  goodwillOfJourney: false,
  usedMaterial: [],
  customerSignature: "",
  technicianSignature: "",
};
